var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 10.1005H17.375C17.5408 10.1005 17.6997 10.1663 17.8169 10.2835C17.9342 10.4007 18 10.5597 18 10.7255C18 10.8912 17.9342 11.0502 17.8169 11.1674C17.6997 11.2846 17.5408 11.3505 17.375 11.3505H4.875C4.70924 11.3505 4.55027 11.2846 4.43306 11.1674C4.31585 11.0502 4.25 10.8912 4.25 10.7255C4.25 10.5597 4.31585 10.4007 4.43306 10.2835C4.55027 10.1663 4.70924 10.1005 4.875 10.1005Z",
    fill: "#464646"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13389 10.7255L10.3176 15.908C10.435 16.0254 10.5009 16.1846 10.5009 16.3505C10.5009 16.5165 10.435 16.6757 10.3176 16.793C10.2003 16.9104 10.0411 16.9763 9.87514 16.9763C9.70917 16.9763 9.55 16.9104 9.43264 16.793L3.80764 11.168C3.74944 11.11 3.70326 11.041 3.67175 10.9651C3.64024 10.8891 3.62402 10.8077 3.62402 10.7255C3.62402 10.6433 3.64024 10.5619 3.67175 10.486C3.70326 10.41 3.74944 10.3411 3.80764 10.283L9.43264 4.65802C9.55 4.54066 9.70917 4.47473 9.87514 4.47473C10.0411 4.47473 10.2003 4.54066 10.3176 4.65802C10.435 4.77538 10.5009 4.93455 10.5009 5.10052C10.5009 5.26649 10.435 5.42566 10.3176 5.54302L5.13389 10.7255Z",
    fill: "#464646"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackIcon);
export default __webpack_public_path__ + "static/media/back_icon.2a774a1007bbe9480af52202dcfbd2bc.svg";
export { ForwardRef as ReactComponent };